<template>
  <div class="text-white" :class="fill ? 'flex flex-1' : ''">
    <button v-if="spin" type="button" v-bind="$attrs" class="flex-1 p-0 px-2 rounded-lg cursor-not-allowed" :class="btnclass">
      <div class="spinner">
        <div class="bounce1"></div>
        <div class="bounce2"></div>
        <div class="bounce3"></div>
      </div>
    </button>
    <button v-else-if="!enabled" :class="['border border-transparent flex-1 p-2 px-4 rounded-lg text-gray-600 cursor-not-allowed', btnclass]">
      <!-- @slot Content of the button (either text or child element). -->
      <slot />
    </button>
    <button
      v-else-if="type == 'submit'"
      type="submit"
      @click="$emit('click')"
      v-bind="$attrs"
      :class="['border border-transparent flex-1 p-2 px-4 rounded-lg text-center cursor-pointer font-normal', btnclass]"
      inputClass="w-full"
    >
      <!-- @slot Content of the button (either text or child element). -->
      <slot />
    </button>
    <button
      v-else
      type="button"
      @click="$emit('click')"
      v-bind="$attrs"
      :class="['border border-transparent flex-1 p-2 px-4 rounded-lg font-normal', btnclass]"
    >
      <slot />
    </button>
  </div>
</template>

<script>
/**
 * Default button component.
 */
export default {
  name: 'FormButton',
  inheritAttrs: false,
  props: {
    /**
     * Set of css classes to apply on the button.
     */
    classes: {
      type: String,
      default: 'bg-blue-600'
    },
    /**
     * Type of button should be either 'button' or 'submit'.
     */
    type: {
      type: String,
      default: 'button'
    },
    /**
     * Toggle whether button should fill the remaining space horizontally.
     */
    fill: {
      type: Boolean,
      default: false
    },
    /**
     * Show spinner icon instead of button text. Useful for triggering after the button is clicked while loading or submitting data.
     */
    spin: {
      type: Boolean,
      default: false
    },
    /**
     * Enable or disable the button. Setting this to false will gray out the button and disable any click events.
     */
    enabled: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    disabled() {
      return !this.enabled
    },
    btnclass() {
      let newClasses = ''
      let classes = this.classes.trim().split(' ')

      classes.forEach((cls) => {
        if (cls.startsWith('bg-')) {
          if (this.enabled) {
            let c = cls.split('-')
            let color = c[1]
            let weight = parseInt(c[2]) == 50 ? 100 : parseInt(c[2])
            let hover = `hover:bg-${color}-${parseInt(weight) + 100}`
            let active = `active:bg-${color}-${parseInt(weight) - 100}`
            newClasses += `${cls} ${hover} ${active} `
          }
        } else {
          newClasses += `${cls} `
        }
      })

      if (!this.enabled) {
        newClasses += 'bg-gray-300 hover:bg-gray-400 active:bg-gray-400'
      }

      // console.log(classes, newClasses)
      return newClasses?.trim()
    }
  }
}
</script>

<style scoped>
.spinner {
  margin: 9px auto 7px auto;
  width: 70px;
  text-align: center;
}
.spinner > div {
  width: 10px;
  height: 10px;
  background-color: #fff;
  border-radius: 100%;
  display: inline-block;
  -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
  animation: sk-bouncedelay 1.4s infinite ease-in-out both;
}
.spinner .bounce1 {
  -webkit-animation-delay: -0.32s;
  animation-delay: -0.32s;
}
.spinner .bounce2 {
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;
}
@-webkit-keyframes sk-bouncedelay {
  0%,
  80%,
  100% {
    -webkit-transform: scale(0);
  }
  40% {
    -webkit-transform: scale(1);
  }
}
@keyframes sk-bouncedelay {
  0%,
  80%,
  100% {
    -webkit-transform: scale(0);
    transform: scale(0);
  }
  40% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}
</style>
